import React, { Component } from 'react';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import {  Pie, Bar } from 'react-chartjs-2';
import { Line } from "react-chartjs-2";
import "react-datepicker/dist/react-datepicker.css";
import { Collapse } from 'react-collapse';
import { ToastContainer, toast } from "react-toastify";


class MonthlyAsrUsageReport extends Component {
    constructor() {
        super();
        this.state = {
            selectedDate: new Date(),
            displayAsrByDay: true,
            displayAsrByLang: true,
            displayKeyPerformanceByHour: true,

            // graphData: 
            asrUsageByDay: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Asr Usage",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            },

            totalEngageTimeData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        label: "# of Asr Usage",
                        borderColor: "#3BA4DC",
                        pointColor: "#fff",
                        responsive: true,
                        pointStrokeColor: "#ccc",
                        pointHoverRadius: 10,
                        backgroundColor: "rgba(60,167,224,0.4)",
                        fill: true
                    }
                ]
            },

            asrUsageByLanguage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            },
            date: null,
            month: '',
            year: '',
        }

    }

    fetchAMonthlyAsrUsageReportDataApi = (month, year,projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
              projectId = localStorage.getItem('currentProjectId');
            }
          }
        var thisController = this;
        $.ajax({
            url: "/api/asr-monthly-analytics",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                month: month,
                year: year
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",

            },

            success: function (res) {
                thisController.state.showLoader = true;
                if (res.success === true) {
                    thisController.state.asrUsageByDay.labels = [];
                    thisController.state.asrUsageByDay.datasets[0].data = [];
                    if (res.success === true && res.result.graphData.length !== 0) {
                        for (var i = 0; i < res.result.graphData.length; i++) {
                            thisController.state.asrUsageByDay.labels.push(res.result.graphData[i].key);
                            thisController.state.asrUsageByDay.datasets[0].data.push(res.result.graphData[i].value);
                        }
                    }

                    thisController.state.totalEngageTimeData.labels = [];
                    thisController.state.totalEngageTimeData.datasets[0].data = [];
                    if (res.success === true && res.result.totalEngagementTimeData.length !== 0) {
                        for (var i = 0; i < res.result.totalEngagementTimeData.length; i++) {
                            thisController.state.totalEngageTimeData.labels.push(res.result.totalEngagementTimeData[i].key);
                            thisController.state.totalEngageTimeData.datasets[0].data.push(res.result.totalEngagementTimeData[i].value);
                        }
                        thisController.setState(thisController.state);
                    }

                    thisController.state.asrUsageByLanguage.labels = [];
                    thisController.state.asrUsageByLanguage.datasets[0].data = [];
                    if (res.success === true && res.result.languageData.length !== 0) {
                        for (var i = 0; i < res.result.languageData.length; i++) {
                            thisController.state.asrUsageByLanguage.labels.push(res.result.languageData[i].key);
                            thisController.state.asrUsageByLanguage.datasets[0].data.push(res.result.languageData[i].value);
                        }
                        thisController.setState(thisController.state);
                    }
                }
                else {
                    thisController.notifyError()
                }
            }
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            No Data found</b>, {
            position: "top-center"
        });
    }
    componentDidMount() {
        var mon = new Array();
        mon[0] = "January";
        mon[1] = "February";
        mon[2] = "March";
        mon[3] = "April";
        mon[4] = "May";
        mon[5] = "June";
        mon[6] = "July";
        mon[7] = "August";
        mon[8] = "September";
        mon[9] = "October";
        mon[10] = "November";
        mon[11] = "December";
        var d = new Date();
        var month = mon[d.getMonth()];
        var year = new Date().getFullYear()
        this.setState({
            month: month,
            year: year
        })

        setTimeout(() => {
            this.fetchAMonthlyAsrUsageReportDataApi(month, year);
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            var mon = new Array();
            mon[0] = "January";
            mon[1] = "February";
            mon[2] = "March";
            mon[3] = "April";
            mon[4] = "May";
            mon[5] = "June";
            mon[6] = "July";
            mon[7] = "August";
            mon[8] = "September";
            mon[9] = "October";
            mon[10] = "November";
            mon[11] = "December";
            var d = thisController.state.selectedDate;
            var month = mon[d.getMonth()];
            var year = new Date().getFullYear()
            thisController.setState({
                month: month,
                year: year
            })
            thisController.projectId = event.projectId;
            thisController.fetchAMonthlyAsrUsageReportDataApi(month, year,event.projectId);
        });
    }

    handleMonthlyChange = () => {
        var month = document.getElementById('selectMonth').value
        var year = document.getElementById('selectYear').value
        this.fetchAMonthlyAsrUsageReportDataApi(month);
    }
    handleYearChange = () => {
        var month = document.getElementById('selectMonth').value
        var year = document.getElementById('selectYear').value
        this.setState({
            month: month,
            year: year
        })
        this.fetchAMonthlyAsrUsageReportDataApi(month, year);
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear()
        this.setState({
            month: month,
            year: year
        })
        this.fetchAMonthlyAsrUsageReportDataApi(month, year);
    }

    refreshData = () => {
        const month = this.state.selectedDate.toLocaleString('default', { month: 'long' });
        const year = this.state.selectedDate.getFullYear()
        this.setState({
            month: month,
            year: year
        })
        this.fetchAMonthlyAsrUsageReportDataApi(month, year);
    }

    resetData = () => {
        this.onDateChange(new Date());
    }

    displayAsrByDay = () => {
        this.state.displayAsrByDay ? this.setState({ displayAsrByDay: false }) :
            this.setState({ displayAsrByDay: true });
    }

    displayAsrByLang = () => {
        this.state.displayAsrByLang ? this.setState({ displayAsrByLang: false }) :
            this.setState({ displayAsrByLang: true });
    }

    displayKeyPerformanceByHour = () => {
        this.state.displayKeyPerformanceByHour ? this.setState({ displayKeyPerformanceByHour: false }) :
            this.setState({ displayKeyPerformanceByHour: true });
    }

    render() {
        return (
            <div>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                <title>Dheeyantra | Dashboard </title>
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Theme style */}
                <link rel="stylesheet" href="dist/css/adminlte.css" />
                <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/custom-style.css" />
                <div className="wrapper">

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item"
                                    style={{ color: '#282a65', marginTop: '10px', marginLeft: '7px' }}>
                                    Monthly Asr Usage Data
                                </h6></div>

                            <div className="d-flex flex-row-reverse pt-2 col-sm-6" style={{ backgroundColor: '#F9F9FB' }}>
                                <button
                                    className="btn action-button"
                                    title="refresh"
                                    onClick={this.refreshData}>
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>

                                <button className="btn action-button"
                                    onClick={this.resetData}>
                                    Reset
                                </button>

                                <DatePicker
                                    id="date"
                                    selected={this.state.selectedDate}
                                    onChange={this.onDateChange}>
                                </DatePicker>

                            </div>
                        </div>
                    </div>
                    {/* Custom Tabs */}
                    <div className="col-12">
                        {/* /.card-header */}
                        <div className="card-body p-0 mb-25">
                            <div className="tab-content col-12 p-0">
                                <div className="tab-pane active show" id="tab_1">
                                    {/* Main content */}
                                    <div className="content">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <h6>
                                                    <img src={this.state.displayAsrByDay ? './assets/images/downward_arrow.png' :
                                                        './assets/images/rightward_arrow.png'}
                                                        onClick={this.displayAsrByDay} />Asr Usage by Day</h6>
                                                <div className="col-lg-12">
                                                    <Collapse isOpened={this.state.displayAsrByDay}>

                                                        <div className="card filled-line-chart">
                                                            <div className="card-body">
                                                                <div className="position-relative mb-4">
                                                                    {/* <canvas id="line-chart" style={{ "height": "197px" }} /> */}
                                                                    <Line data={this.state.asrUsageByDay} width="1000" height="250" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>

                                                <div className="col-lg-12">
                                                    <h6>
                                                        <img src={this.state.displayAsrByLang ? './assets/images/downward_arrow.png' :
                                                            './assets/images/rightward_arrow.png'}
                                                            onClick={this.displayAsrByLang} />Asr Usage by Language</h6><br />
                                                    <Collapse isOpened={this.state.displayAsrByLang}>
                                                        <div className="col-lg-3" />
                                                        <div className="col-lg-6">
                                                            <div className="card monthly-conversation-chart">
                                                                <div className="card-body">
                                                                    <div className="chartHeight">
                                                                        <Pie data={this.state.asrUsageByLanguage} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3" />
                                                        {/* /.card */}
                                                    </Collapse>
                                                </div>
                                                <div className="col-lg-12">
                                                    <h6>
                                                        <img src={this.state.displayKeyPerformanceByHour ? './assets/images/downward_arrow.png' :
                                                            './assets/images/rightward_arrow.png'}
                                                            onClick={this.displayKeyPerformanceByHour} />Per Day Engagement Time(hrs)<br /><br />
                                                    </h6>
                                                    <Collapse isOpened={this.state.displayKeyPerformanceByHour}>
                                                        <div className="card filled-line-chart">
                                                            <div className="card-body">
                                                                <div className="position-relative mb-4">
                                                                    <Bar data={this.state.totalEngageTimeData} width="1000" height="250" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>

                                                <ToastContainer className="Toast-at-center" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MonthlyAsrUsageReport;


// WEBPACK FOOTER //
// ./src/asrUi/reports/MonthlyAsrUsageReport.js